module.exports = __webpack_public_path__ + "static/media/civil6.3838eb38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civil6.jpg
// module id = 5780
// module chunks = 0